import {defineStore} from 'pinia'
import {useLocalStorage} from '@/composables/use-local-storage.js'
import {themes} from '@/constants/app.js'
import {ref, unref, watchEffect} from 'vue'

/**
 * User settings store
 */
export const useUserSettingsStore = defineStore('userSettings', () => {

  //Composables
  const {getFromLocalStorage, setInLocalStorage} = useLocalStorage()

  //Refs
  const theme = ref(getFromLocalStorage('theme', themes.LIGHT))

  //Mutators
  const setTheme = value => theme.value = unref(value)

  //Watchers
  watchEffect(() => setInLocalStorage('theme', theme.value))

  //Interface
  return {

    //Refs
    theme,

    //Mutators
    setTheme,
  }
})
